import React from 'react'
import CardNew from 'presentation/shared/components/CardNew'
import * as S from './styles'
import SupportTextNew from 'presentation/shared/components/SupportTextNew'
import HeadingNew from 'presentation/shared/components/HeadingNew'

interface ReasonIndicatorCardProps {
  title: string
  quantity: number
  percent: string
  onSurgery?: boolean
  onSelect?: () => void
}

export const ReasonIndicatorCard = ({
  title,
  quantity,
  percent,
  onSurgery,
  onSelect
}: ReasonIndicatorCardProps) => {
  function quantityColorDefinition() {
    if (onSurgery && quantity > 0) {
      return 'primary500'
    }

    if (onSurgery && quantity === 0) {
      return 'primary200'
    }

    if (!onSurgery && quantity > 0) {
      return 'secondary500'
    }

    if (!onSurgery && quantity === 0) {
      return 'secondary200'
    } else return 'neutral500'
  }

  function percentColorDefinition() {
    if (quantity === 0) {
      return 'neutral500'
    } else return 'neutral700'
  }

  function titleColorDefinition() {
    if (quantity === 0) {
      return 'neutral500'
    } else return 'neutral700'
  }

  return (
    <CardNew
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: '8px',
        alignItems: 'center',
        minHeight: '120px'
      }}
      radius="xsmall"
      shadow="medium"
      onClick={onSelect}
    >
      <S.PercentWrapper>
        <SupportTextNew
          weight="bold"
          color={quantityColorDefinition()}
          size="xxlarge"
          style={{ borderRight: '1px solid #EDEDEF', paddingRight: '16px' }}
        >
          {quantity}
        </SupportTextNew>

        <SupportTextNew
          weight="bold"
          color={percentColorDefinition()}
          size="large"
        >
          {percent}
        </SupportTextNew>
      </S.PercentWrapper>

      <HeadingNew
        as="h5"
        weight="semiBold"
        color={titleColorDefinition()}
        size="xsmall"
        style={{ marginRight: 'auto' }}
      >
        {title}
      </HeadingNew>
    </CardNew>
  )
}
